export default {
  usuarioList: {
    value: [],
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/notificacao-usuario/ModalNotificacao-form.js